var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPear = function SvgPear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pear_svg__a)",
    d: "M125.6 62.541c-5.72-1.15-12.26-4.57-16.01 4.98-16.01 40.833-31.02 56.764-36.02 82.655-4.56 23.622 18.67 66.165 49.02 72.695 37.02 7.971 46.97-7.84 59.03-23.901 21.49-28.622 21.01-58.754-5-94.606-14.19-19.552-21.67-31.682-28.01-35.853-8.52-5.59-8.9-3.14-23.01-5.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pear_svg__b)",
    d: "M130.64 46.34c1.3-2.56 7.2-1.01 8.23 1.01 1.03 2.03-4.11 10.62-4.11 18.491 0 7.87-12.34 9.9-9.26 2.8 1.03-10.14 4.11-20.28 5.14-22.3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pear_svg__a",
    x1: 135,
    x2: 135,
    y1: 223.511,
    y2: 65.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1988BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pear_svg__b",
    x1: 132,
    x2: 132,
    y1: 72.742,
    y2: 45.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3094C1"
  })))));
};
export default SvgPear;